// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"19":"6ae66a42","286":"140a4545"}[chunkId] + ".chunk.css";
};